module.exports = __webpack_public_path__ + "static/media/screenshot(30).455814c7.jpg";